import { render, staticRenderFns } from "./rule-view-hist-tabs.vue?vue&type=template&id=260d4cfd&scoped=true&lang=pug&"
import script from "./rule-view-hist-tabs.vue?vue&type=script&lang=ts&"
export * from "./rule-view-hist-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./rule-view-hist-tabs.vue?vue&type=style&index=0&id=260d4cfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d4cfd",
  null
  
)

export default component.exports